module.exports = __webpack_public_path__ + "img/product4.7ef04995.png";